import i18n from "config/i18next";

i18n.addResources("es", "templateCreation", {
  templateCreation: "Creación de plantilla",
  regionLabel: "Región *",
  workzoneLabel: "Zona de operación *",
  slotStartLabel: "Comienzo del turno *",
  slotEndLabel: "Fin del turno *",
  regionPlaceholder: "Seleccioná la región",
  workzonePlaceholder: "Seleccioná la zona",
  slotStartPlaceholder: "Ingresá el horario de comienzo",
  slotEndPlaceholder: "Ingresá el horario de finalización",
  validTitle: "Plantilla creada con éxito",
  validMessage: "La plantilla con código {{data}} fue creada correctamente",
  createTemplateTitle: "Estás por crear una plantilla",
  createTemplateMessage:
    "La misma se encontrará visible a partir de {{date}} a las {{time}}hs",
});
